import { IStaticConfig } from '../typings';

const emeaObj: IStaticConfig = {
  isEMEA : true
};

export const siteidEMEA = {
  siteid3        : emeaObj,
  siteid6        : emeaObj,
  siteid7        : emeaObj,
  siteid8        : emeaObj,
  siteid9        : emeaObj,
  siteid11       : emeaObj,
  siteid20       : emeaObj,
  siteid63       : emeaObj,
  siteid64       : emeaObj,
  siteid65       : emeaObj,
  siteid66       : emeaObj,
  siteid67       : emeaObj,
  siteid73       : emeaObj,
  siteid1236     : emeaObj,
  siteid1294     : emeaObj,
  siteid70403    : emeaObj,
  siteid70406    : emeaObj,
  siteid70420    : emeaObj,
  siteid70463    : emeaObj,
  siteid70465    : emeaObj,
  siteid70472    : emeaObj,
  siteid10122006 : emeaObj,
  siteid70473    : emeaObj,
  siteid72       : emeaObj
};
